import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/employee/[id]/dearest/sessions/page";

export const Route = createFileRoute("/employee/$id/dearest/sessions")({
  component: Page,
});
